// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 939) return "static/chunks/939-5c4caf7d949b4773.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"296":"ea88be26","2937":"eabe11fc"}[chunkId] || chunkId) + "." + {"296":"f3d92e846a690d6d","1167":"b6249644cba9a008","2937":"1d527542829faf22","8997":"4abc375fc8f553d1","9260":"71bf9ccbd23d2478"}[chunkId] + ".js";
};